import axios from '../index'
import { tokenGenerator } from '../util'
import { qs } from '../../routing'

const { REACT_APP_API_GATEWAY, REACT_APP_WEBSITE_BRAND } = process.env

export async function getCmsContent(brand?: string) {
  const cid = qs(document.location.search, 'cid')
  const brandAllowed =
    !brand || brand === 'vwfs' ? REACT_APP_WEBSITE_BRAND : brand
  const res = await axios.get(
    `${REACT_APP_API_GATEWAY}/cms-content/pt/${brandAllowed}`,
    {
      headers: {
        ...tokenGenerator(cid),
      },
    }
  )
  return res.data
}
